import globals from "./global-variables";

export const NormalText = {
  fontFamily: `${globals.fontFamily.robotoRegular}, sans-serif`,
  color: globals.colors.black,
  fontSize: globals.fontSize.xs,
  textAlign: "center"
};

export const ButtonText = {
  ...NormalText,
  fontSize: globals.fontSize.sm
};

export const QuestionHeader = {
  ...NormalText,
  fontFamily: `${globals.fontFamily.avalonBold}, sans-serif`,
  fontSize: globals.fontSize.lg,
  [`@media (${globals.breakpoints.$md})`]: {
    fontSize: globals.fontSize.xl
  }
};

export const LinkText = {
  textDecoration: "none",
  color: globals.colors.black
};

export const BreadcrumbText = {
  ...NormalText,
  fontFamily: `${globals.fontFamily.robotoMedium}, sans-serif`,
  fontSize: globals.fontSize.xxs
};
